import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../../components/Header'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '../../backend/firebase'
import './CollectionsScreen.css'

const CollectionsScreen = () => {
  const { uid } = useParams()
  const navigate = useNavigate()
  const [collections, setCollections] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const privateRef = collection(db, "Users", uid, "collections")
        const publicRef = query(collection(db, "collections"), where("uid", "==", uid))

        const [privateSnap, publicSnap] = await Promise.all([
          getDocs(privateRef),
          getDocs(publicRef)
        ])

        const privateData = privateSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          source: "private"
        }))

        const publicData = publicSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          source: "public"
        }))

        setCollections([...privateData, ...publicData])
      } catch (error) {
        console.error("Error fetching collections:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchCollections()
  }, [uid])

  const formatDate = (timestamp) => {
    if (!timestamp) return ''
    const date = timestamp.toDate()
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  if (loading) {
    return (
      <div className="seta-collections-container">
        <div className="seta-collections-content">
          <div style={{textAlign: 'center', padding: '40px', color: '#666'}}>
            Loading collections...
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="seta-collections-container">
      <div className="seta-collections-content">
        <div className="seta-collections-header">
          <span
            onClick={() => navigate(`/add-collection/${uid}`)}
            className="seta-add-collection-button"
          >
            Add collection
          </span>
        </div>
        <div className="seta-collections-title-section">
          <h1 className="seta-collections-title">My SETA Collections</h1>
        </div>
        <div className="seta-collections-grid">
          {collections.map((col) => (
            <div 
              onClick={col.isPrivate ? () => navigate(`/private-collection/${col.id}`) : () => navigate(`/public-collection/${col.id}`)} 
              key={col.id} 
              className="seta-collection-card"
            >
              <div className="seta-collection-header">
                <div className="seta-collection-info">
                  <div className="seta-collection-avatar">
                    {col.collectionName?.[0]?.toUpperCase() || 'C'}
                  </div>
                  <div className="seta-collection-details">
                    <p className="seta-collection-name">{col.collectionName}</p>
                  </div>
                </div>
                <div className={`seta-privacy-badge ${col.isPrivate ? 'seta-private' : 'seta-public'}`}>
                  {col.isPrivate ? "Private" : "Public"}
                </div>
              </div>
              <div className="seta-collection-description">
                {col.description || <span className="seta-no-description">No description</span>}
              </div>
              <div className="seta-collection-footer">
                <div className="seta-collection-source">
                  {col.source === "private" ? "Private" : "Public"}
                </div>
                <div className="seta-collection-date">
                  {formatDate(col.createdAt)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CollectionsScreen